import emailjs from '@emailjs/browser';

// Initialize EmailJS with public key
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
emailjs.init(PUBLIC_KEY);

/**
 * Sends an email using EmailJS
 * @param {Object} formData - The form data containing name, email, subject, and message
 * @returns {Promise} - Resolves with success response, rejects with error
 */
export const sendEmail = async (formData) => {
  try {

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      subject: formData.subject,
      message: formData.message,
    };

    const response = await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams,
      PUBLIC_KEY
    );

    return response;
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
}; 